var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, LitElement } from 'lit';
import '@shoelace-style/shoelace/dist/components/avatar/avatar.js';
import '@shoelace-style/shoelace/dist/components/dropdown/dropdown.js';
import '../../atoms/icon-button/icon-button.js';
import { property, state } from 'lit/decorators.js';
import styles from './UserMenu.styles';
// FIX ME
// const defaultImage = "./assets/images/unknown.png"
export class SgdfUserMenu extends LitElement {
    constructor() {
        super(...arguments);
        this.isOpen = false;
    }
    handleOpen() {
        this.isOpen = !this.isOpen;
    }
    render() {
        return html `
            <sl-dropdown placement="bottom-end" distance="10">
                <div class="user-menu" slot="trigger">
                    <sl-avatar
                        class="avatar"
                        .image=${this.imageUrl}
                    ></sl-avatar>
                    <div class="user-detail">
                        <span class="username"> ${this.username} </span>
                        <span class="role"> ${this.appRole} </span>
                    </div>
                    <sgdf-icon-button name="chevron-down"></sgdf-icon-button>
                </div>
                <div class="user-menu__menu" part="menu">
                    <slot name="menu"></slot>
                </div>
            </sl-dropdown>
        `;
    }
}
SgdfUserMenu.styles = styles;
__decorate([
    property()
], SgdfUserMenu.prototype, "username", void 0);
__decorate([
    property()
], SgdfUserMenu.prototype, "appRole", void 0);
__decorate([
    property()
], SgdfUserMenu.prototype, "imageUrl", void 0);
__decorate([
    state()
], SgdfUserMenu.prototype, "isOpen", void 0);
//# sourceMappingURL=UserMenu.js.map